(function () {
  var H = 'most-searched__btn--hidden';

  function init(wrap) {
    if (wrap._msInited) return;
    var track = wrap.querySelector('.most-searched__track');
    var btnL = wrap.querySelector('.most-searched__btn--left');
    var btnR = wrap.querySelector('.most-searched__btn--right');
    if (!track || !btnL || !btnR) return;
    wrap._msInited = true;

    function update() {
      var s = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      if (s <= 2) {
        btnL.classList.add(H);
        btnL.setAttribute('hidden', '');
      } else {
        btnL.classList.remove(H);
        btnL.removeAttribute('hidden');
      }
      if (max < 2 || s >= max - 2) {
        btnR.classList.add(H);
      } else {
        btnR.classList.remove(H);
      }
    }

    track.addEventListener('scroll', update, { passive: true });
    update();

    btnL.addEventListener('click', function () {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    });
    btnR.addEventListener('click', function () {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    });

    var prevX = 0,
      startX = 0,
      dragging = false,
      hasDragged = false,
      pendingId = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      prevX = e.clientX;
      startX = e.clientX;
      pendingId = e.pointerId;
      hasDragged = false;
    });

    track.addEventListener('pointermove', function (e) {
      if (pendingId === null) return;
      if (e.buttons === 0) {
        endDrag();
        return;
      }
      if (!dragging) {
        if (Math.abs(e.clientX - startX) < 5) return;
        dragging = true;
        track.setPointerCapture(pendingId);
        track.classList.add('is-dragging');
      }
      hasDragged = true;
      track.scrollTo({ left: track.scrollLeft + (prevX - e.clientX) * 0.6, behavior: 'instant' });
      prevX = e.clientX;
    });

    function endDrag() {
      dragging = false;
      pendingId = null;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          hasDragged = false;
        }
      },
      true,
    );

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function run() {
    document.querySelectorAll('.most-searched').forEach(init);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  window.addEventListener('load', run);
  if (window.MutationObserver) {
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }
})();
